import { render } from "./calendar.svg?vue&type=template&id=69ca749e"
const script = {}
script.render = render

export default script